import React, { useContext, useEffect, useState } from 'react';
import Fade from 'react-reveal/Fade';
// import Tilt from 'react-tilt';
import { Container, Row, Col } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import Title from '../Title/Title';
// import ProjectImg from '../Image/ProjectImg';
import ImageCol from './ImageCol';
import TextCol from './TextCol';

const Projects = () => {
  const { projects } = useContext(PortfolioContext);
  const datas = projects.datas || [];

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="projects">
      <Container>
        <div className="project-wrapper">
          <Title title={projects.projectsTitle} />
          {datas.map((project) => {
            const {
              title, info, info2, url, img, id,
            } = project;

            return (
              <Row key={id}>
                {
                  img
                    ? (
                      <ImageCol
                        title={title}
                        url={url}
                        img={img}
                        lg={info ? 8 : 12}
                        sm={12}
                        isDesktop={isDesktop}
                        isMobile={isMobile}
                      />
                    )
                    : null
                }
                {
                  info
                    ? (
                      <TextCol
                        title={title}
                        url={url}
                        info={info}
                        info2={info2}
                        lg={info ? 4 : 12}
                        sm={12}
                        isDesktop={isDesktop}
                        isMobile={isMobile}
                      />
                    )
                    : null
                }
              </Row>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Projects;
